<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancelChanges()">{{ 'Close' | translate }}</ion-button>
    </ion-buttons>
    <!--<ion-title>{{ title }}</ion-title>-->
    <ion-buttons slot="end">
      <ion-button (click)="confirmChanges()">{{ 'Validate' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar placeholder="{{ 'Search' | translate }}" [debounce]="500" (ionInput)="searchbarInput($event)" #searchBar></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content color="light" class="ion-padding">
  <ion-list id="modal-list" [inset]="true">
    <ion-item *ngFor="let item of items; trackBy: trackItems" (click)="checkCB($event, item)">
      <ion-label [innerHTML]="item.name"></ion-label>
      <ion-checkbox
        slot="end"
        [value]="item.id" 
        [checked]="isChecked(item.id)"
      ></ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>